const appConfig = {
    apiPrefix: '/api',
    authenticatedEntryPath: '/tech',
    techAuthenticatedEntryPath: '/tech',
    unAuthenticatedEntryPath: '/tech-sign-in',
    tourPath: '/',
    locale: 'en',
    enableMock: true,
    showFooter:false,
}

export default appConfig
